export default __webpack_public_path__ + "static/media/025-fire-alarm.403f2068.png";